<section>
  <div class="flex flex-row justify-between items-center">
    <h2>Dettaglio informazioni di bilancio</h2>
    <div class="flex justify-end flex-wrap">
      <button mat-flat-button color="accent" style="margin: 12px;" aria-label="Modifica dati di bilancio"
        [disabled]="praticaProgressService.isFrozen && !praticaProgressService.canEditDataOnSignedPratica"
        (click)="openBudgetDialog('budgetData')">
        MODIFICA DATI
      </button>
      <button mat-flat-button color="accent" style="margin: 12px 0;" aria-label="Modifica anni di riferimento"
        [disabled]="praticaProgressService.isFrozen && !praticaProgressService.canEditDataOnSignedPratica"
        (click)="openBudgetDialog('budgetYears')">
        MODIFICA ANNI DI RIFERIMENTO
      </button>
    </div>

  </div>
  <div *ngIf="blockingKpiHasError && !couldntRetrieveData" class="warn-text">
    <p>Per procedere con la richiesta di finanziamento è necessario compilare i seguenti campi </p>
    <ul>
      <li>Crediti verso clienti esigibili entro l’esercizio</li>
      <li>Crediti verso clienti esigibili oltre l’esercizio</li>
      <li>Debiti tributari esigibili entro l’esercizio</li>
      <li>Debiti tributari esigibili oltre l’esercizio</li>
      <li>Debiti verso istituti previdenziali esigibili entro l’esercizio</li>
      <li>Debiti verso istituti previdenziali esigibili oltre l’esercizio</li>
      <li>Debiti verso fornitori esigibili entro l’esercizio</li>
      <li>Debiti verso fornitori esigibili oltre l’esercizio</li>
      <li>Debiti verso banche esigibili entro l’esercizio</li>
      <li>Debiti verso banche esigibili oltre l’esercizio</li>
    </ul>

  </div>

  <div *ngIf="couldntRetrieveData" class="warn-text">
    <p>Non è stato possibile recuperare i dati di bilancio. Si prega di inserire manualmente le informazioni elencate
      sotto.</p>
  </div>

  <div class="scrollable-table-container" style="margin-bottom: 4rem;">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows
      class="table table-primary-color budget-details-table">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Indicatori </th>
        <td mat-cell *matCellDef="let element"> {{element.label}} </td>
      </ng-container>

      <ng-container matColumnDef="previus">
        <th mat-header-cell *matHeaderCellDef> {{budgetDetails[0]?.annoPrecedente || 'Anno precedente'}} </th>
        <td mat-cell *matCellDef="let element" [ngClass]="{'warning-text': element.modificatoPrecedente}">
          {{element.previus | currency:'EUR':'symbol':'1.2-2':'it'}} </td>
      </ng-container>

      <ng-container matColumnDef="current">
        <th mat-header-cell *matHeaderCellDef> {{budgetDetails[0]?.annoCorrente || 'Anno corrente'}} </th>
        <td mat-cell *matCellDef="let element" [ngClass]="{'warning-text': element.modificatoCorrente}">
          {{element.current | currency:'EUR':'symbol':'1.2-2':'it'}} </td>
      </ng-container>

      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef> Note </th>
        <td mat-cell *matCellDef="let element">{{element.note}}</td>
      </ng-container>

      <ng-container matColumnDef="categoria">
        <td [attr.colspan]="displayedColumns.length" mat-cell *matCellDef="let element">
          <div style="color: white">
            {{element.categoria | label }}
          </div>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Azioni </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!praticaProgressService.isFrozen">
            <button mat-icon-button aria-label="Elimina dati di bilancio" matTooltip="Elimina dati di bilancio"
              (click)="onDeleteBudgetDetails(element)">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="data-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.hidden-row]="!row.name"
        [class.is-expanded]="row.name">
      </tr>

      <tr mat-row *matRowDef="let row; columns: ['categoria']" colspan class="hidden-row primary-bg"
        [class.is-expanded]="!row.name">
      </tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="5">Nessuna informazione di bilancio
          presente al momento.
        </td>
      </tr>
    </table>
  </div>
</section>